import React from 'react'
import { useLocation } from 'react-router-dom'
import { GOVERNANCE_STAGES, governanceReferenceForPath, governanceStageForPath } from './processRouteMap'

export default function GovernanceContextHeader() {
  const { pathname } = useLocation()
  const stageKey = governanceStageForPath(pathname)
  const stage = GOVERNANCE_STAGES.find(({ key }) => key === stageKey)
  const context = governanceReferenceForPath(pathname)
  return <header className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
    <dl className="flex flex-wrap gap-x-8 gap-y-2 text-sm">
      <div><dt className="text-xs font-semibold uppercase text-slate-500">Governance Area</dt><dd className="font-semibold text-slate-900">Investment Governance</dd></div>
      {stage && <div><dt className="text-xs font-semibold uppercase text-slate-500">Current Stage</dt><dd className="font-semibold text-slate-900">{stage.label}</dd></div>}
      {context && <div><dt className="text-xs font-semibold uppercase text-slate-500">Context Reference</dt><dd className="font-mono text-slate-900">{context.type}: {context.reference}</dd></div>}
    </dl>
  </header>
}
